// extracted by mini-css-extract-plugin
export default {"stock_search":"index_stock_search_9J5fT clearfix","text":"index_text_Wa0Nq","btn":"index_btn_tAu6m"};